// TeaBoardRegistration.jsx
import React from "react";

export default function TeaBoardRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Tea Board Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining Tea Board Registration as required for tea manufacturing, trading, and export activities.
          </p>
          <p className="text-gray-700">
            Complete registration process including Form 9 application submission, factory/garden inspection, license issuance, QR code integration, Tea Board portal compliance, and export facilitation under Tea Act 1953.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Tea industry compliance and manufacturing) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Tea Board registration for tea manufacturing and export"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless Tea Board application processing and license approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business registration certificate (GSTIN, incorporation documents)</li>
                <li>PAN card (company and authorized signatory)</li>
                <li>Factory or warehouse details (lease deed, layout plan, FSSAI license)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Specialized expertise in Tea Board compliance across Assam, West Bengal, Tamil Nadu with proven success in factory registrations and export licensing.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Industry-specific Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Tea Act 1953 and Tea Board Rules knowledge including Form 9 applications, QR code compliance, factory inspection readiness, export license facilitation, FSSAI-Tea Board integration, and WTO tea standards.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise Form 9 preparation, factory layout validation, FSSAI license coordination, PAN/GSTIN verification, QR code implementation support, inspection documentation packages, and Tea Board portal submissions ensuring first-time approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service from application submission through factory inspection clearance, license issuance, QR code activation, export documentation, Tea Board portal compliance, and ongoing regulatory advisory for manufacturing/trading operations.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
